"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// ============================================================================
// STYLED COMPONENTS
// ============================================================================

const NestedNavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NestedNavContainer",
  class: "pl-n5wuk6"
});
const ItemText = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "ItemText",
  class: "pl-i1gooy53"
});
const NestedDropdown = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NestedDropdown",
  class: "pl-n1cxom5z"
});
const ItemList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "ItemList",
  class: "pl-i1ssbd8f"
});
const IconChevronRight = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconChevronRight",
  class: "pl-i9ys3vz"
});
const NestedNavContainerWithHover = /*#__PURE__*/(0, _react2.styled)(NestedNavContainer)({
  name: "NestedNavContainerWithHover",
  class: "pl-n19qs2mh"
});

// ============================================================================
// MAIN COMPONENT
// ============================================================================

/**
 * SubmenuHoverItem Component
 *
 * A submenu item that shows horizontal nested menu items on hover as a positioned dropdown.
 * Used for creating nested submenus within dropdown content.
 * @param {Object} props - Component props
 * @returns {React.ReactElement} SubmenuHoverItem component
 */
function SubmenuHoverItem({
  children,
  itemText,
  active,
  moreMenuRef
}) {
  const itemTextRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(NestedNavContainerWithHover, {
    className: "submenu-hover-item",
    "data-cy": "nested-nav-item"
  }, /*#__PURE__*/_react.default.createElement(ItemText, {
    className: "submenu-hover-item__text",
    "data-cy": "nested-item-text",
    ref: itemTextRef,
    "data-active": active,
    tabIndex: 0
  }, itemText, children && moreMenuRef && /*#__PURE__*/_react.default.createElement(IconChevronRight, {
    className: "submenu-hover-item__chevron",
    "data-cy": "nested-item-chevron"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-right"
  }))), children && moreMenuRef && /*#__PURE__*/_react.default.createElement(NestedDropdown, {
    className: "submenu-hover-item__dropdown",
    "data-cy": "nested-item-submenu"
  }, /*#__PURE__*/_react.default.createElement(ItemList, null, children)));
}
SubmenuHoverItem.propTypes = {
  children: _propTypes.default.node,
  itemText: _propTypes.default.string.isRequired,
  active: _propTypes.default.bool,
  moreMenuRef: _propTypes.default.object
};
SubmenuHoverItem.defaultProps = {
  active: false,
  children: null,
  moreMenuRef: null
};
var _default = exports.default = SubmenuHoverItem;